import styled, { css, ThemeProvider, isStyledComponent } from 'styled-components';

export const CSSthemer = styled.div`

  ${({theme}) => theme === 'misha' && css`

    & .xsui-content-block {
      border-radius: 2px;
    }


    & .xsui-content-block--appearance-branding, .xsui-content-block--appearance-primary {
      /* box-shadow: 0 8px 32px 0 hsla(0, 0%, 0%, 0.12), 0 1px 4px 0 rgba(0, 0, 0, .1); */
      box-shadow: 0 8px 13px 0 hsla(0,0%,0%,0.05), 0 1px 4px 0 rgba(0,0,0,.1);
      /* box-shadow: none; */
    }


    & .pam__title h1 {
      color: white !important;
    }
    & .pam__title .ui-navigation__item:not(.ui-navigation__item--active) {
      color: white !important;
    }

    & .pam__title .ui-navigation__item:not(.ui-navigation__item--active) {
      color: white !important;
    }


    .pa_prj {
      box-shadow: 0 8px 32px 0 hsla(216, 67%, 55%, 0), 0 1px 4px 0 #0073f726;
      /* box-shadow: none; */
    }


    /* & h1 {
      color: white !important;
    } */
  `}


`

















export const themes = [
  {
    id: 'magenta',
    name: 'Magenta Dark',
    colorText: '#D6E0E7',
    colorAccent: '#FF005B',
    colorAccentText: '#F6FAFF',
    colorBg: '#011627',

    borderRadius: 8,
    backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',

    cardWidth: 240,
    cardPadding: 24,

    boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
    transitionTime: '0.3s',
    transitionEasing: 'ease-in-out',
    transition: 'all 0.3s ease-in-out',
    transitionStyle: '0.3s ease-in-out',
    fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },

  {
    id: 'pop',
    name: 'Pop_Art',
    colorText: "#ffff00",
    colorAccent: "#FF0000",
    colorBg: "#000C68",
    colorAccentText: "white",
    borderRadius: 20,

    backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
    cardWidth: 240,
    cardPadding: 24,
    boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
    transitionTime: '0.3s',
    transitionEasing: 'ease-in-out',
    transition: 'all 0.3s ease-in-out',
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: '0.3s ease-in-out',
    fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },
  {
    id: 'arizona',
    name: 'Arizona Green Tea',
    colorText: "blue",
    colorAccent: "white",
    colorBg: "#40E0D0",
    colorAccentText: "black",
    borderRadius: 10,

    cardWidth: 240,
    cardPadding: 24,
    backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
    boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
    transitionTime: '0.3s',
    transitionEasing: 'ease-in-out',
    transition: 'all 0.3s ease-in-out',
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: '0.3s ease-in-out',
    fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },
  {
    id: 'wes',
    name: 'Wes Anderson',
    colorText: "#E7C865",
    colorAccent: "#AAD8C8",
    colorBg: "#433446",
    colorAccentText: "#433446",
    borderRadius: 4,

    cardWidth: 240,
    cardPadding: 24,
    backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
    boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
    transitionTime: '0.3s',
    transitionEasing: 'ease-in-out',
    transition: 'all 0.3s ease-in-out',
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: '0.3s ease-in-out',
    fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },
  // {
  //   id: 'moon',
  //   name: 'Moon',
  //   colorText: "#000000",
  //   colorAccent: "#FF005B",
  //   colorBg: "#FFFFFF",
  //   colorAccentText: "#FFFFFF",
  //   borderRadius: 0,

  //   backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
  //   cardWidth: 240,
  //   cardPadding: 24,
  //   boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
  //   transitionTime: '0.3s',
  //   transitionEasing: 'ease-in-out',
  //   transition: 'all 0.3s ease-in-out',
  //   // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
  //   transitionStyle: '0.3s ease-in-out',
  //   fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  // },
  {
    id: 'iconic',
    name: 'Iconic',
    colorText: '#0079F4',
    colorAccent: '#D2F51D',
    colorBg: '#040A20',
    colorAccentText: "#FFFFFF",
    borderRadius: 3,

    backgroundUrl: 'https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg',
    cardWidth: 240,
    cardPadding: 24,
    boxShadow: '0 5px 12px 0px rgba(0,0,0,0.2)',
    transitionTime: '0.3s',
    transitionEasing: 'ease-in-out',
    transition: 'all 0.3s ease-in-out',
    // transition: `all ${theme['transitionTime']} ${theme['transitionTime']}`,
    transitionStyle: '0.3s ease-in-out',
    fontFamily: '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },






]

